class InterviewSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  event(){
    const mySwiper = new Swiper('.swiper', {

      loop: false,
      slidesPerView: 3,

      // breakpoints: {
      //   789: {
      //     loop: false,
      //     slidesPerView: 3,
      //   },
      // },
    });
  }
}